import React from 'react';
import PropTypes from 'prop-types';
import { useSelector } from "react-redux";

import IconCart from '../content/list/svg/IconCart';
import IconAddedCart from '../content/list//svg/IconAddedCart';
import useCart from '../cart/hooks/useCart';

function AddCartButton() {
  const playlistAutomix = useSelector( state => state.playlistAutomix );
  const cartItems = useSelector( state => state.cartItems );
  const isInCart = cartItems.some( id => id === playlistAutomix.tracks[playlistAutomix.active].id);
  const { addToCart } = useCart(playlistAutomix.tracks[playlistAutomix.active]);

  return (
    <div  className={`align`} onClick={addToCart} >
      { isInCart 
        ? <IconAddedCart color={'#8C8C8C'} className={`cf-icon-all-v2`} size={21} /> 
        : <IconCart color={'#8C8C8C'} className={`cf-icon-v2`} size={21} />
      }
    </div>
  )
}

AddCartButton.propTypes = {
  showAddCart: PropTypes.bool
}

export default AddCartButton;
